<template>
  <ActionPopover :show="show" @hide="$emit('hide')">
    <ul class="action-popover-list">
      <li
        v-for="item in list"
        :key="item.title"
        class="action-popover-list__item"
      >
        <span
          class="action-popover-list__item-content"
          @click="emitCommand(item.command)"
        >
          <i :class="item.elIcon" class="action-popover-list__item-icon" />
          {{ item.title }}
        </span>
      </li>
    </ul>
  </ActionPopover>
</template>

<script>
import ActionPopover from './ActionPopover';

export default {
  name: 'ActionPopoverList',
  components: {
    ActionPopover,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    emitCommand(command) {
      this.$emit('command', command);
    },
  },
};
</script>

<style lang="scss">
.action-popover-list {
  margin: 0;
  list-style-type: none;
  color: $lb-black;
  width: rem-calc(320px);

  padding: 0 $global-padding;

  font-size: 13px;

  &__item {
    padding: $global-padding * 0.8 0;

    display: flex;
    align-items: center;

    &-content {
      cursor: pointer;
      transition-duration: 0.3s;

      &:hover {
        color: $lb-color-primary;
      }
    }

    &-icon {
      color: #c0c4cc;

      margin-left: $global-margin * 0.625;
    }

    &:not(:last-child) {
      border-bottom: 1px dashed #dfdfdf;
    }
  }
}
</style>
